module.exports = __webpack_public_path__ + "media/GLAMPING_6.8c042413.webm";